import { render } from "./LoginCard.vue?vue&type=template&id=0ba64c3e&scoped=true"
import script from "./LoginCard.vue?vue&type=script&lang=js"
export * from "./LoginCard.vue?vue&type=script&lang=js"

import "./LoginCard.vue?vue&type=style&index=0&id=0ba64c3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba64c3e"]])

export default __exports__